// extracted by mini-css-extract-plugin
export var actionIcon = "_to-0";